/* eslint-disable no-param-reassign */
import React from 'react'
import { Security } from '@okta/okta-react'
import { SimpleNavBar } from './components/SimpleNavBar/SimpleNavBar'
import { Dashboard } from './components/Dashboard/Dashboard'
import { AccessLevelProvider } from './context/AccessLevelContext'
import { useAuthService } from './auth/authService'

export function App() {
  const authService = useAuthService()

  return (
    <div id="content">
      <section className="splunk-login">
        <Security
          oktaAuth={authService.oktaAuth}
          onAuthRequired={authService.customAuthHandler}
          restoreOriginalUri={authService.restoreOriginalUri}
        >
          <AccessLevelProvider>
            <SimpleNavBar />
            <Dashboard />
          </AccessLevelProvider>
        </Security>
      </section>
    </div>
  )
}
